var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 123,
    viewBox: "0 0 94 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M68.6468 88.2896L58.9813 83.6106L48.0736 96.6188L46.2421 94.0189L48.5218 76.5323L39.4925 49.3547L18.7998 56.6806L24.3113 70.5555L42.0241 113.196L45.9304 122.857L46.383 120.052L50.6991 103.595L56.7315 96.8963L67.5026 96.0681L50.349 84.1955L68.6468 88.2896Z",
    fill: "#2A72DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9835 37.1192C58.3826 37.1192 63.5701 32.1133 63.5701 25.9382C63.5701 19.7631 58.3826 14.7572 51.9835 14.7572C45.5845 14.7572 40.397 19.7631 40.397 25.9382C40.397 32.1133 45.5845 37.1192 51.9835 37.1192Z",
    fill: "#0047AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5648 104.474L75.5163 108.013C73.4671 104.115 69.1211 101.533 64.1987 101.925C58.4396 102.386 53.846 107.018 53.6069 112.59C53.5173 114.669 54.0125 116.633 54.9602 118.332L54.4821 118.571L50.7167 120.458L45.9352 122.857C43.4676 117.286 41.38 111.693 39.6168 106.173C39.3308 105.289 39.0533 104.397 38.7886 103.513V103.505C38.5922 102.856 38.3958 102.19 38.2464 101.673C38.097 101.161 37.9945 100.807 37.9945 100.807C34.831 89.7709 32.8971 79.1876 31.7359 69.9022L31.7444 70.0815C30.199 59.8909 30.1221 48.7953 30.1221 48.7953C30.0709 46.951 30.0581 45.2818 30.0581 43.8089C30.0581 42.9167 30.0581 42.0927 30.0752 41.3499C30.1221 38.3956 30.2289 36.6495 30.2417 36.4019V36.372L36.4149 37.2088L39.5314 37.7296C39.5101 38.0028 39.4973 38.2803 39.4973 38.5578C39.4973 44.7353 44.6843 49.7388 51.0795 49.7388C56.416 49.7388 60.9029 46.2637 62.2477 41.5292L65.5777 42.0842L70.658 42.9764V42.9978C70.6452 43.1728 70.5086 45.666 70.5257 49.6748C70.5257 49.6748 70.8202 60.9796 71.2984 65.3427C71.9003 71.5287 72.9164 78.3807 74.6369 85.0791C74.6454 85.1004 74.6497 85.1175 74.654 85.1389C75.3029 87.7729 75.3925 87.8541 75.3968 87.8541C77.1216 93.8181 79.444 99.5559 82.569 104.47L82.5648 104.474Z",
    fill: "#6495ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0068 65.2423C22.7444 65.2444 25.2367 66.2956 27.1025 68.0149L27.0991 67.9946C27.0991 67.9946 32.6019 69.1943 35.3559 67.5711C34.6684 70.581 32.0764 74.5627 30.4213 76.8799C29.8458 82.12 25.3993 86.2018 20.0068 86.2018H10.4797C4.69577 86.2018 0 81.506 0 75.722C0 69.9406 4.69153 65.2465 10.4795 65.2423H20.0068Z",
    fill: "url(#paint0_radial_88_12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4327 44.426C12.0784 21.2084 30.0409 2.36392 51.6346 2.36392C73.2286 2.36392 90.7338 19.8888 90.7338 41.5069C90.7338 63.125 73.2286 80.6498 51.6346 80.6498",
    stroke: "#CAE4FF",
    strokeWidth: 3.06,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2429 51.9044C17.9322 51.9044 20.1123 49.7244 20.1123 47.0351C20.1123 44.3458 17.9322 42.1657 15.2429 42.1657C12.5536 42.1657 10.3735 44.3458 10.3735 47.0351C10.3735 49.7244 12.5536 51.9044 15.2429 51.9044Z",
    fill: "#CAE4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1306 51.9044C91.8199 51.9044 94 49.7244 94 47.0351C94 44.3458 91.8199 42.1657 89.1306 42.1657C86.4413 42.1657 84.2612 44.3458 84.2612 47.0351C84.2612 49.7244 86.4413 51.9044 89.1306 51.9044Z",
    fill: "#CAE4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3733 33.6262L16.4657 33.3177C18.0974 32.8572 19.7936 33.8065 20.2541 35.4382L25.6423 54.5278C26.1028 56.1595 25.1535 57.8555 23.5218 58.316L22.4294 58.6244C19.1098 59.5615 15.6591 57.6298 14.722 54.3104L11.0592 41.3333C10.1222 38.0137 12.0538 34.5632 15.3733 33.6262Z",
    fill: "url(#paint1_linear_88_12)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5544 84.5081C53.2412 84.5081 55.4193 82.3276 55.4193 79.6379C55.4193 76.9481 53.2412 74.7676 50.5544 74.7676C47.8676 74.7676 45.6895 76.9481 45.6895 79.6379C45.6895 82.3276 47.8676 84.5081 50.5544 84.5081Z",
    fill: "url(#paint2_radial_88_12)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.821 33.2128L87.9391 33.4095C91.3362 34.007 93.6058 37.2453 93.0083 40.6424L90.6727 53.9227C90.0753 57.3198 86.8369 59.5894 83.4398 58.9919L82.3219 58.7952C80.6522 58.5016 79.5365 56.9099 79.8301 55.2402L83.266 35.7045C83.5596 34.0347 85.1513 32.9192 86.821 33.2128Z",
    fill: "url(#paint3_linear_88_12)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78596 78.1568C10.0137 78.1568 11.0089 77.1615 11.0089 75.9338C11.0089 74.7061 10.0137 73.7108 8.78596 73.7108C7.55825 73.7108 6.56299 74.7061 6.56299 75.9338C6.56299 77.1615 7.55825 78.1568 8.78596 78.1568Z",
    fill: "#0047AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5609 78.1568C16.7886 78.1568 17.7838 77.1615 17.7838 75.9338C17.7838 74.7061 16.7886 73.7108 15.5609 73.7108C14.3331 73.7108 13.3379 74.7061 13.3379 75.9338C13.3379 77.1615 14.3331 78.1568 15.5609 78.1568Z",
    fill: "#0047AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3358 78.1568C23.5635 78.1568 24.5587 77.1615 24.5587 75.9338C24.5587 74.7061 23.5635 73.7108 22.3358 73.7108C21.1081 73.7108 20.1128 74.7061 20.1128 75.9338C20.1128 77.1615 21.1081 78.1568 22.3358 78.1568Z",
    fill: "#0047AB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1279 2C59.311 2.02223 66.4148 4.12029 72.4522 7.9817C72.8077 8.20887 73.2349 8.55692 72.8549 8.88677C72.6444 9.06948 72.3338 8.91239 72.066 8.73984C60.8953 1.57785 45.9696 1.00114 34.2721 7.38108L34.0642 7.48714C33.641 7.58474 33.2959 7.00677 33.7272 6.7144C39.3041 3.6414 45.5849 2.0343 51.8903 2.00021L52.1279 2ZM21.295 17.6364C21.6511 17.712 21.7256 18.0956 21.3894 18.5487C18.663 22.253 16.6219 26.447 15.4249 30.8768C15.4249 30.8768 15.2782 31.1881 15.019 31.19C14.7565 31.1917 14.5378 30.9821 14.6073 30.656C15.8707 25.9808 18.0514 21.5933 20.8906 17.8009C20.8906 17.8009 21.0234 17.6089 21.295 17.6364ZM72.3491 73.9572C72.7031 74.004 72.8714 74.4994 72.5456 74.7353C68.4866 77.351 63.9162 79.1537 59.2672 80.0659C59.2672 80.0659 58.8508 80.0528 58.7752 79.7543C58.6143 79.119 60.0444 79.0576 61.1569 78.7756C65.0331 77.7926 68.7243 76.1877 72.0868 74.0233C72.0868 74.0233 72.1065 73.9515 72.3491 73.9572Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_88_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1048 66.6587) scale(24.007 24.0071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CAE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A1DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_12",
    x1: 17.6952,
    y1: 36.3998,
    x2: 22.0455,
    y2: 58.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_88_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4314 79.5866) scale(4.4839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_88_12",
    x1: 88.2135,
    y1: 39.1815,
    x2: 84.1158,
    y2: 59.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport5);
export default __webpack_public_path__ + "static/media/Support (5).b849447091d549672386eb265e0346b9.svg";
export { ForwardRef as ReactComponent };